module.exports = __webpack_public_path__ + "static/Anon-Ray-3d078e881b5987a0a2aba837e89621e9.png";